<template>
    <div ref="selectboxContainer" id="select-box-container" class="select-box-section" :class="{'disabled-select-box-section':disabled}">
        <div ref="selectButton" class="select-box-container select-box-button">
            <div class="select-box-btn" :class="iconClass" v-if="!hide_icon && !icon_src"></div>
            <img v-if="!hide_icon && icon_src" width="20" :src="icon_src" alt="">
            <div v-if="!is_multiple && !title" class="select-box-div">
                <div class="select-count">
                    <span v-if="singleValue">{{singleValue}}</span>
                    <span v-else class="value-placeholder">{{placeholder}}</span>
                </div>
                <div class="fas fa-angle-down"></div>
                <div v-if="with_search && selectedText && !show_selection_inside" class="fas fa-times" @click="clearSearch"></div>
            </div>
            
            <div v-else class="select-box-div" :style="{ 'margin-left': hide_icon ? '0' : 'auto' }">
                <input v-virtual-keyboard v-if="with_search" type="text" placeholder="Search.." autocomplete="false" id="selectbox-search-input"
                    v-model="searchText" @focus="onInputFocus" ref="searchInput">
                <div v-else class="select-count">
                    <span class="count-title">{{ title }}</span>
                    <span> {{ count }}</span>
                </div>
                <div class="fas fa-angle-down"></div>
                <div v-if="with_search && searchText" class="fas fa-times" @click="clearSearch"></div>
            </div>
        </div>
        <div class="search-menu select-box-menu">
            <div v-for="(option, index) in visibleOptions" class="search-option" :key="`${id}-${option.name}-${index}`"
                :class="{ 'checked-property': option.isChecked }" @click.self="changeFilterProperty(option)" :title="option.name">
                <label :class="{ 'd-none': !show_checkbox }" class="checkbox__container">
                    <input type="checkbox" :id="`${id}-${option.name}-${index}`" @change="filterCheckChanged($event, option)"
                        :checked="option.isChecked" />
                    <span class="checkmark"></span>
                </label>
                <label class="noselect option-name" :for="`${id}-${option.name}-${index}`">{{ option.name }}</label>
                <label class="noselect" v-for="action in actions" :key="action.tooltip">
                    <i class="action-button" :class="action.icon" @click="action.action(option.name)" :title="action.tooltip"></i>
                </label>
            </div>
            <div class="load-more-button" @click="maxCount+=50" v-if="visibleOptions.length < filteredOptions.length">
                <span>Load more .. </span>
            </div>
        </div>
        <span v-if="with_search && selectedText && !show_selection_inside" class="selected-text" :style="{'padding': hide_icon ? '0' : 'auto' }" :title="selectedText">{{ selectedText }}</span>
    </div>
</template>
<script>
export default {
    name: 'CustomSelectBox',
    props: ['id', 'disabled', 'is_multiple', 'with_search', 'show_checkbox', 'title', 'options', "custom_icon_class","show_selection_inside", 'icon_src', 'hide_icon', 'actions'],
    data() {
        return {
            // It is sent to the parent every time it is changed.
            searchText: "",
            placeholder: "Please select ...",

            // Same as options property, but it is mutable.
            mutableOptions: this.options ? this.options : [],
            maxCount: 100
        };
    },
    methods: {
        changeFilterProperty(option) {
            // If it is multiple, The parent component is responsible for the list update, and the watch event will update the local one.
            if (!this.is_multiple) {
                this.selectSingleOption(option);
                
                this.$refs.selectButton.parentElement.classList.remove("expanded-select-box")
            }

            this.$emit('change_filter_property', option);
        },
        filterCheckChanged($event, option) {
            // If it is multiple, The parent component is responsible for the list update, and the watch event will update the local one.            
            if (!this.is_multiple) {
                this.selectSingleOption(option);

                this.$refs.selectButton.parentElement.classList.remove("expanded-select-box")
            }

            let value = $event.target.checked;
            this.$emit('filter_check_changed', {
                value, option
            });
        },
        selectSingleOption(option) {
            this.mutableOptions.forEach(option => {
                option.isChecked = false
            })

            option.isChecked = true;
        },
        toggleExpandParentClass(e) {
            if (e.target == this.$refs.searchInput) return;

            this.$refs.selectButton.parentElement.classList.toggle("expanded-select-box");
        },
        closeDropdownEventHandler(e) {
            var ignoreClickOnMeElements = document.getElementsByClassName('expanded-select-box');

            var elementsOutOfClick = Array.from(ignoreClickOnMeElements).filter(element => !element.contains(e.target));

            elementsOutOfClick.forEach(() => this.$refs.selectButton.parentElement.classList.remove('expanded-select-box'));
        },
        onInputFocus() {
            this.$refs.selectButton.parentElement.classList.remove("expanded-select-box")
            this.$refs.selectButton.parentElement.classList.add("expanded-select-box");
        },
        clearSearch() {
            this.searchText = ''
            this.$emit('clear_search')
        }
    },
    computed: {
        count: function () {
            return this.mutableOptions.filter(o => o.isChecked && o.name !== 'Select All').length ?? 0;
        },
        filteredOptions: function () {
            return this.mutableOptions.filter(o => o.name && o.name.toLowerCase().includes(this.searchText.toLowerCase()));
        },
        visibleOptions: function () {
            return this.filteredOptions.slice(0,this.maxCount);
        },
        singleValue: function () {
            let selected = this.mutableOptions.filter(o => o.isChecked);
            return selected.length > 0 ? selected[0].name : ""
        },
        iconClass: function () {
            return this.custom_icon_class ? this.custom_icon_class : "fas fa-filter"
        },
        selectedText: function () {
            let text = ''
            if (this.with_search) {
                this.mutableOptions.forEach(option => {
                    if (option.isChecked) {
                        text += `${option.name}, `
                    }
                })

                if (text.length > 0) {
                    text = text.substring(0, text.length - 2); 
                }
            }
            return text;
        },
    },
    mounted() {
        this.$refs.selectButton.addEventListener('click', this. toggleExpandParentClass);
    },
    beforeDestroy() {
        window.removeEventListener("click", this.closeDropdownEventHandler);

        let elements = document.getElementsByClassName("select-box-button");

        Array.from(elements).forEach(element => {
            element.removeEventListener('click', this.toggleExpandParentClass);
        });
    },
    created() {
        window.addEventListener("click", this.closeDropdownEventHandler);
    },
    watch: {
		selectedText: {
			handler: function (value, oldValue) {
				if (value != oldValue) {
					if (!this.is_multiple) {
						this.searchText = value
					}
				}
			}
		},
        searchText: {
            handler: function (value, oldValue) {
				if (value != oldValue) {
                    this.$emit('search_text_changed', value);
                    if (this.filteredOptions.length == 0) {
                        this.$emit('filter_search_changed', value);
                    }
                    this.maxCount = 100;
				}
			}
        },
        options: {
            handler: function (value) { 
                this.mutableOptions = value;
            }
        }
	},
}
</script>
<style>
.select-box-section {
    min-width: 130px;
    position: relative;
    width: 100%;
}

.select-box-section .search-option.checked-property {
    color: inherit;
}

.select-box-section .search-option {
    column-gap: 5px;
}

.select-box-section .search-option:hover {
    color: white !important;
    background-color: var(--v-primary-lighten1);
}

.select-box-container {
    display: flex;
    align-items: center;
    padding: 8px;
    border-radius: 6px;
    box-shadow: 0px 0px 0px 1px #ab96962b;
    cursor: pointer;
}

.dark-theme .select-box-container {
    box-shadow: 0px 0px 0px 1px #333C43;
}

.select-box-section:hover .select-box-container {
    background-color: whitesmoke;
}


.select-box-container .select-box-div {
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;
    margin-left: 14px;
    font-size: 14px;
    color: inherit;
}

.select-box-container .select-box-div .option-name {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    width: 85%;
}

.select-box-container .select-box-div .select-count {
    display: flex;
    width: 100%;
    justify-content: space-between;
    margin-right: 10px;
    gap: 10px;
}

.select-box-section:not(.disabled-select-box-section) .select-box-container .fas,
.select-box-section:not(.disabled-select-box-section) .select-box-container .fab,
.select-box-section:not(.disabled-select-box-section) .select-box-container .fa {
    /* color: var(--v-primary-base); */
}

.select-box-container .fas,
.select-box-container .fab,
.select-box-container .fa {
    display: flex;
    justify-content: center;
    align-items: center;
    color: inherit;
}

.select-box-container #search-options {
    width: 100%;
    background-color: transparent;
    border: none;
    height: 100%;
    cursor: pointer;
    color: var(--v-primary-base);
}

.select-box-container #search-options:focus {
    border-bottom: none !important;
}

.select-box-btn {
    width: 20px;
    height: 20px;
    font-size: 15px;
    cursor: pointer;
    color: gray;
}

.select-box-btn:hover {
    color: var(--v-primary-base);
}

.select-box-btn:hover .search-menu {
    display: flex;
}

.select-box-btn:hover .search-menu {
    display: flex;
}

.search-menu {
    display: none;
    flex-direction: column;
    background-color: white;
    border-radius: 6px;
    margin-left: -127px;
    margin-top: -3px;
    z-index: 53;
    position: absolute;
    border: 1px solid lightgray;
    width: 100%;
    height: auto;
    max-height: 300px;
    overflow: auto;
}

.search-menu .search-option .right-delete-icon {
    display: none
}

.search-menu .search-option:hover .right-delete-icon {
    display: flex;
    justify-content: center;
    align-items: center;
}

.expanded-select-box .select-box-menu {
    margin-left: 0px !important;
    margin-top: 0px !important;
}

.expanded-select-box .select-box-menu {
    display: flex !important;
}

.search-menu {
    font-size: 14px;
}

.search-option .checkbox__container {
    padding-left: 20px;
}

#select-box-container #selectbox-search-input {
    border: unset;
    height: 100%;
    padding: 0;
    border-radius: 0;
    background: transparent;
    width: 80%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: 500;
}

.selected-text {
    font-size: 12px;
    color: #5f5f5f;
    display: flex;
    padding: 10px 0px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 90%;
}

.selected-text:hover {
    background-color: transparent;
}

.select-box-section:not(.disabled-select-box-section) {
    color: var(--v-primary-base);
}

.disabled-select-box-section {
    pointer-events: none;
    color: #8b8b8b;
    background: #dedede;

}

#select-box-container .load-more-button {
    margin: 10px 10px;
}

#select-box-container .option-name {
    display: block;
    margin: auto;
    height: auto;
    width: -webkit-fill-available;
    padding: 5px 0px;
}
#select-box-container .select-box-menu .action-button {
    width: 30px;
    color: #8b8b8b;
}
#select-box-container .select-box-menu .action-button:hover {
    color: var(--v-primary-base);
}

#select-box-container .value-placeholder {
    color: #c292aa
}
</style>